export default {
  badge: 'Bedž',
  close: 'Zatvori',
  dataIterator: {
    noResultsText: 'Nisu pronađene odgovarajuće stavke',
    loadingText: 'Učitavanje...',
  },
  dataTable: {
    itemsPerPageText: 'Redaka po stranici:',
    ariaLabel: {
      sortDescending: ': Sortirano silazno. Odaberite za uklanjanje sortiranja.',
      sortAscending: ': Sortirano uzlazno. Odaberite za silazno sortiranje.',
      sortNone: ': Nije sortirano. Odaberite za uzlazno sortiranje.',
    },
    sortBy: 'Sortirajte po',
  },
  dataFooter: {
    itemsPerPageText: 'Stavki po stranici:',
    itemsPerPageAll: 'Sve',
    nextPage: 'Sljedeća stranica',
    prevPage: 'Prethodna stranica',
    firstPage: 'Prva stranica',
    lastPage: 'Posljednja stranica',
    pageText: '{0}-{1} od {2}',
  },
  datePicker: {
    itemsSelected: '{0} odabrano',
  },
  noDataText: 'Nema dostupnih podataka',
  carousel: {
    prev: 'Prethodno',
    next: 'Sljedeće',
    ariaLabel: {
      delimiter: 'Carousel slide {0} of {1}',
    },
  },
  calendar: {
    moreEvents: 'Još {0}',
  },
  fileInput: {
    counter: 'Odabranih datoteka: {0}',
    counterSize: 'Odabranih datoteka: {0} ({1} ukupno)',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
}
